import * as React from 'react';
import * as classes from './iframe-viewer.scss';
import { SpinnerPage } from '../spinner/spinner-page.component';

// tslint:disable-next-line:interface-name
export interface IFrameHolderComponentProperties {
  readonly name: string;
  readonly src: string; // url to the iframe's source
  readonly onFrameLoad?: (e: Event) => void;
}

export interface FrameHolderComponentState {
  readonly isLoading: boolean;
}

export class IFrameHolder extends React.Component<IFrameHolderComponentProperties, FrameHolderComponentState> {
  frameRef: HTMLIFrameElement | null;
  onFrameLoad: (e: Event) => void;

  constructor(props: IFrameHolderComponentProperties) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  shouldComponentUpdate(nextProps: IFrameHolderComponentProperties, nextState: FrameHolderComponentState) {
    return nextState.isLoading !== this.state.isLoading;
  }

  componentDidMount() {
    if (this.frameRef) {
      if (this.props.onFrameLoad) {
        this.frameRef.addEventListener('load', this.props.onFrameLoad);
      } else {
        this.frameRef.addEventListener('load', this.handleIFrameTasks);
      }
    }
  }
  componentWillUnmount() {
    if (this.frameRef) {
      if (this.props.onFrameLoad) {
        this.frameRef.addEventListener('load', this.props.onFrameLoad);
      } else {
        this.frameRef.addEventListener('load', this.handleIFrameTasks);
      }
    }
  }
  handleIFrameTasks = (e: PageTransitionEvent) => {
    return;
  };
  handleLoad = (e: any) => {
    if (this.props.onFrameLoad) {
      this.props.onFrameLoad(e);
    }
    this.setState({ isLoading: false });
  };

  render() {
    const { src, name } = this.props;
    return (
      <>
        {this.state.isLoading ? <SpinnerPage /> : null}
        <iframe
          className={['col-xs-12', classes.checkoutFrame].join(' ')}
          src={src}
          name={name}
          onLoad={this.handleLoad}
          ref={f => (this.frameRef = f)}
        />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/iframe-viewer/iframe-viewer.component.tsx